import { render, staticRenderFns } from "./InjuryReport.vue?vue&type=template&id=c03e4c78&scoped=true&"
import script from "./InjuryReport.vue?vue&type=script&lang=ts&"
export * from "./InjuryReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03e4c78",
  null
  
)

export default component.exports